import { useGateValue } from '@statsig/react-bindings'

import { GO_TO_REDIRECT_DICTIONARY } from 'constants/go-to'
import { URL_PUBLIC } from 'constants/urls'
import { GoToLink } from '@types'
import { useService } from 'services'

import { useQuery } from './use-query'
import { useRouter } from './use-router'
import { useGoTo } from './use-go-to'

export function useGoToBootstrap() {
  const { events } = useService()
  const { query, toObject } = useQuery()
  const router = useRouter()
  const { persistState } = useGoTo()
  const featureFlags = {}

  const urlKey = query.get('urlKey') || query.get('url_key')

  if (urlKey && GO_TO_REDIRECT_DICTIONARY[urlKey]) {
    Object.keys(GO_TO_REDIRECT_DICTIONARY[urlKey]).forEach((key) => {
      if (key !== 'default') {
        featureFlags[key] = useGateValue(key)
      }
    })
  } else {
    router.pushPreserveSearch(URL_PUBLIC)
    events.error(new Error('URL Key not found'))
  }

  const getUrl = (urlKey: string) => {
    const goToItem =
      Object.keys(featureFlags).find((key) => {
        if (featureFlags[key] && featureFlags[key].value) {
          return key
        }
      }) || 'default'
    return GO_TO_REDIRECT_DICTIONARY[urlKey][goToItem]
  }

  function pushPathname(pathname: string) {
    pathname.indexOf('http') > -1
      ? (window.location.href = pathname)
      : router.pushPreserveSearch(pathname)
  }

  const redirect = () => {
    if (urlKey) {
      const link: GoToLink = getUrl(urlKey)
      const data = toObject()
      persistState(urlKey, data)
      if (link.target === '_blank') {
        window.open(`${link.url}${location.search}`, '_blank')
      } else {
        pushPathname(link.url)
      }
    }
  }

  return {
    redirect,
  }
}
